import $ from 'jquery';

class ResponsiveNav {

  constructor() {
    this._options = {
      stackSize: 'medium'
    };

    this._startedElm = false;
    this._oldScroll = 0;
    this._navPre = false;

    const limitedList = $('*[data-navbar]');
    if (limitedList.length) {
      // start only one
      this.init(limitedList[0]);
    }
  }

  init(el) {
    this._startedElm = el;

    this._oldScroll = $(window).scrollTop();
    this._navPre = $(this._startedElm).find('.l-navbar__pre');

    const controllNav = () => {
      if (Foundation.MediaQuery.atLeast(this._options.stackSize)) {
        this._controllFixedNav();
      } else {
        this._controllFlexNav();
      }
    }

    const productsStick = $('.c-product-page__details > .sticky').first();
    const fixProductStick = productsStick.length ? () => {
      if ($(this._startedElm).is('.l-navbar--fixed')) {
        $(productsStick).css('transform', `translateY(0)`);
      } else {
        const size = 32 - $(window).scrollTop();
        const adjustment = size > 0 ? size : 0;
        $(productsStick).css('transform', `translateY(${adjustment}px)`);
      }
    } : () => {};

    controllNav();
    fixProductStick();

    $(window).on('scroll changed.zf.mediaquery', event => {
      controllNav();
      fixProductStick();
    });

    $(window).on('opened.zf.offcanvas', event => {
      this.releaseHeader();
    });
  }

  fixHeader() {
    //check if isn't fixed already
    if (!$(this._startedElm).is('.l-navbar--fixed')) {

      //check if has offcanvas and if it does, check if it is open
      if (!$('.off-canvas').length || $('.off-canvas').length && !$('.off-canvas').is('.is-open')) {

        this._headerHeight = $(this._startedElm).height();
        $(this._startedElm).addClass('l-navbar--fixed');
        $('body').css('padding-top', this._headerHeight);
      }
    }
  }

  releaseHeader() {
    if ($(this._startedElm).is('.l-navbar--fixed')) {
      $(this._startedElm).removeClass('l-navbar--fixed');
      $('body').css('padding-top', 0);
    }
  }

  _controllFixedNav(navPre){
    // console.log('fixed version');
    let navPreHeight = this._navPre.outerHeight();
    if ($(window).scrollTop() > navPreHeight) {
      this.fixHeader();
    } else {
      this.releaseHeader();
    }
  }

  _controllFlexNav(navPre, oldScroll){
    // console.log('mobile version');
    if ($(window).scrollTop() > this._navPre.outerHeight() && this._oldScroll > $(window).scrollTop()) {
      this.fixHeader();
    } else {
      this.releaseHeader();
    }
    this._oldScroll = $(window).scrollTop();
  }
}

export default new ResponsiveNav;
